export default "__VITE_ASSET__BqViQBN$__"